import Api from '@/api/Api'

export default {
  upload (formData) {
    return Api().post('UserFile/upload', formData)
  },

  getFile (params) {
    return Api().post('UserFile/get_file', params)
  },
  createFile (params) {
    return Api().post('UserFile/create_file', params)
  },
  updateFile (params) {
    return Api().put('UserFile/update_file/' + params._id, params)
  },
  deleteFile (params) {
    return Api().put('UserFile/delete_file/' + params._id, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/UserFileAPI.js